/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "1.5.0",
  "gitBuildTime": "2026-05-07T17:14:20.173Z",
  "gitBuildVersion": "1.5.0",
  "gitCommitId": "dc1f5ee",
  "gitCommitIdFull": "dc1f5ee2679196384a4ebf8ae1c78fd1f53d9548",
  "gitCommitTime": "2026-05-07T17:12:56.000Z",
  "version": "1.5.0-2026-05-07T17:12:56.000Z-(dc1f5ee)"
};
